export const RUNS_PER_PAGE = 50;
export const VIEW_STACK_LOCALSTORAGE_KEY = "viewStackKey";
